import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as classroomGroupActions from '../../../actions/classroom/classroomGroupActions';
import CustomIcon from '../../common/CustomIcon';

class StudentGroupDelete extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.deleteGroup = this.deleteGroup.bind(this);
  }

  static propTypes = {
    group: PropTypes.object,
    classroomGroupActions: PropTypes.object
  };

  deleteGroup() {
    const { classroomGroupActions, group } = this.props;
    classroomGroupActions.setGroupToRemove(group);
  }

  render() {
    return (
      <div className="student-group-delete" onClick={this.deleteGroup} data-cy="deleteGroupButton">
        <CustomIcon name="waste-can" size={24} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentGroupDelete);
